import { render, staticRenderFns } from "./InstitutionClientFileInfo.vue?vue&type=template&id=94f9f82c&scoped=true&"
import script from "./InstitutionClientFileInfo.vue?vue&type=script&lang=ts&"
export * from "./InstitutionClientFileInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionClientFileInfo.vue?vue&type=style&index=0&id=94f9f82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f9f82c",
  null
  
)

export default component.exports